import {
  UMNG_PUBLIC,
} from './base';

export const server = {
  serverTimezone: `${UMNG_PUBLIC}/server-time`,
};

export default server;
